import React, {useEffect, useState} from 'react'
import {AppBar, Grid, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types'
import InfoData from './InfoData';
import clsx from 'clsx';
import Tr from 'translations/Translations';
import OpenBarText from './OpenBarText';
import InfoBarTitle from './InfoBarTitle';
import HeaderService from 'services/HeaderService';
import {withRouter} from "react-router";
import {connect} from 'react-redux'
import querystring from "querystring";
import {ProcedureTypeTr} from "constants/ProcedureType";

const style = theme => ({
	root: {
		borderBottom: `solid 1px ${theme.palette.primary.main}`,
		width: 'unset',
		padding: theme.spacing(1),
		paddingLeft: theme.spacing(4),
		minHeight: theme.mixins.toolbar.minHeight + theme.spacing(4),
		backgroundColor: theme.palette.background.greyBackground,
	},
	open: {
		maxHeight: 500,
		transition: theme.transitions.default.open('max-height'),
		'& $content': {
			margin: `${theme.spacing(1)}px 0`,
			padding: `${theme.spacing(1)}px 0`
		}
	},
	close: {
		maxHeight: 0,
		overflow: 'hidden',
		transition: theme.transitions.default.close('max-height'),
		'& $content': {
			height: 0,
			opacity: 0,
			zIndex: -1,
			marginTop: theme.spacing(-1)
		},
	},
	content: {
		borderColor: theme.palette.primary.contrastText,
		borderStyle: 'solid',
		borderWidth: '1px 0',
	},
	title: {
		width: "100%"
	},
	infoContainer: {
		'&>*': {
			flexGrow: 1,
			flexShrink: 0,
			flexBasis: 0,
		}
	},
})

function InfoBar({
	contractor = false,
	classes,
	match,
	location,
	headerData = {}
}) {
	const [attach, setAttach] = useState(false)
	let id = match.params.id ? match.params.id : -1;
	if(!headerData.name) {
		const urlParams = querystring.parse(location.search.slice(1));
		if(urlParams.procedureType) {
			headerData = { name:  `${Tr('new_procedure')}: ${ProcedureTypeTr[urlParams.procedureType]}`}
		}
	}


	useEffect(() => {
		HeaderService.get(id)
	}, [id]);

	const handleAttachClick = () => {
		setAttach(!attach)
	}

	return (
		<>
			<AppBar
				id='appBar'
				className={clsx(
					classes.root, {
						[classes.open]: attach,
						[classes.close]: !attach,
					}
				)}
				component='div'
				elevation={0}
				position='relative'
			>
				<Grid
					container
					direction='column'
				>
					<Grid item className={classes.title}>
						<InfoBarTitle title={headerData.name} number={headerData.number} attach={attach} contractor={contractor}/>
					</Grid>
					{headerData &&
					<Grid item className={classes.content}>
						<Grid
							container
							className={classes.infoContainer}
						>
							<Grid item>
								<InfoData headerData={headerData} contractor={contractor}/>
							</Grid>
						</Grid>
					</Grid>
					}
					{id > 0 &&
						<Grid item>
							<OpenBarText
								onClick={handleAttachClick}
								text={attach ? Tr('hide_info_bar') : Tr('show_info_bar')}
								rotate={attach}
							/>
						</Grid>
					}
				</Grid>
			</AppBar>
		</>
	)
}

InfoBar.propTypes = {
	title: PropTypes.string,
}

InfoBar.defaultProps = {
}

export default connect((state) => ({
	headerData: state.resources.demandHeader
}), {

})(withRouter(withStyles(style)(InfoBar)));